import { network } from 'services/network';

import { QueryParams } from 'api/queries/clustersList.query';

export const getClustersList = (params: QueryParams) => {
    return network
        .post('api/bo/getClustersList', {
            paFileMetaDataIds: params.idList,
            projectId: params.projectId,
            clusterType: params.compare,
        })
        .then((response) => {
            return response.data;
        });
};
